import script from "./ArticleComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleComment.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleComment.vue?vue&type=style&index=0&id=4d69f53e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d69f53e"]])

export default __exports__